import { DEPLOY_ENV } from '~/common/utils/env.util.ts';

export const TOKEN_KEY = `launcher.token.${DEPLOY_ENV}`;
